import Vue from "vue";
import { MATERIAL_TYPE_MAP } from "@/core/const/global-const";

Vue.filter("materialTypeText", function (value) {
  if (value === undefined || value === null || value === "") {
    return "未知";
  }
  // 如果是数组，处理多个类型
  if (Array.isArray(value)) {
    return value.map((type) => MATERIAL_TYPE_MAP[type] || "未知").join(",");
  }
  return MATERIAL_TYPE_MAP[value] || "未知";
});
